import React from 'react';

export default function NaoSeAplica() {
	return <p className="text-xs text-glassColor">N.A.</p>;
}
